
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'HappyKidsHomeBlogSection',

  components: { VueSlickCarousel },

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
  },

  data() {
    return {
      isActive: true,
      activeBlogCategory: '',
      settings: {
        "dots": true,
        "arrows": true,
        "focusOnSelect": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "touchThreshold": 5,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 1,
              "infinite": true,
              "dots": true,
              "arrows": true
            }
          },
          {
            "breakpoint": 760,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 1,
              "dots": true,
              "arrows": false
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "dots": true,
              "arrows": false
            }
          }
        ]
      }
    }
  },

  computed: {
    activeBlogItems() {
      if(this.data && this.data.BlogTopics) {
        const parsedArray = JSON.parse(JSON.stringify(this.data.BlogTopics))
        const filtered = parsedArray.filter(item => item.Topic === this.activeBlogCategory)
        return filtered
      }
      return null
    }
  },

  mounted() {
    const topics = JSON.parse(JSON.stringify(this.data.BlogTopics))
    if(topics && topics[0] && topics[0].Topic)
    this.setActiveBlogCategory(topics[0].Topic)
  },

  methods: {
    setActiveBlogCategory(category) {
      this.activeBlogCategory = category
    },
    categoryCodes() {
      return this.data?.BlogTopics.map(x => x.Topic)
    },
    filteredBlogItems(category) {
      return this.data?.BlogTopics.filter(blog => blog.Topic == category);
    },
  },
}
